/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permission_SubmitInputs */

const en_agent_authorization_permission_submit = /** @type {(inputs: Agent_Authorization_Permission_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create one pending directory submission for editorial review`)
};

const zh_agent_authorization_permission_submit = /** @type {(inputs: Agent_Authorization_Permission_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建一条等待编辑审核的目录提交`)
};

/**
* | output |
* | --- |
* | "Create one pending directory submission for editorial review" |
*
* @param {Agent_Authorization_Permission_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permission_submit = /** @type {((inputs?: Agent_Authorization_Permission_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permission_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permission_submit(inputs)
	return zh_agent_authorization_permission_submit(inputs)
});
export { agent_authorization_permission_submit as "agent.authorization.permission.submit" }